// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fea026ae","389":"38a834ea","455":"e48b1a57","977":"ac561f96"}[chunkId] + ".chunk.js";
};